import React from 'react';

export const BackIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18.414" height="16.636" viewBox="0 0 18.414 16.636">
      <path d="M387,633.333h8.889A7.111,7.111,0,0,1,403,640.444v1.778m-16-8.889,5.333,5.333M387,633.333,392.333,628" transform="translate(-385.586 -626.586)" fill="none" stroke="#0a3256" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
    </svg>
  );
};

export default BackIcon;
